<mat-form-field appearance="outline" class="w-100 m-t-5"
  [ngStyle]="{'margin-bottom': control?.errors?.pattern ? '6%' : '0px'}" [ngClass]="{
  'mat-form-field-compact': size === 'compact',
  'mat-form-field-xs': size === 'xs'}">
  <input matInput [type]=" newHide ? 'password' : 'text'" [formControl]=" control" />
<button mat-icon-button matSuffix class="compact-icon-btn" (click)="newHide = !newHide" [attr.aria-label]="'Hide password'"
  [attr.aria-pressed]="hide">
  <mat-icon>{{ newHide ? 'visibility_off' : 'visibility' }}</mat-icon>
</button>

<mat-error *ngIf=" control?.invalid && control?.touched" class="text-danger">

  <!-- rquired  -->
  <ng-container *ngIf="control?.errors?.required; else elseErrors" class="text-danger">{{'errors.required' |
    translate}}</ng-container>

  <!-- pattern  -->
  <ng-template #elseErrors>
    <ng-container *ngIf="control?.errors?.pattern">
      {{'errors.password' | translate}}
    </ng-container>
    <ng-container *ngIf="control?.errors?.passwordMismatch">
      {{ 'errors.passwordMismatch' | translate }}
    </ng-container>
  </ng-template>
</mat-error>

</mat-form-field>